var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "form",
      {
        on: {
          keydown: function ($event) {
            return _vm.clearInput($event.target.name)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("form-input", {
                attrs: {
                  label: _vm.Lang.get("messages.name"),
                  name: "name",
                  model: _vm.request,
                  errors: _vm.formErrors,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("form-input", {
                attrs: {
                  label: _vm.Lang.get("messages.email"),
                  name: "email",
                  model: _vm.request,
                  errors: _vm.formErrors,
                  type: "email",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("form-input", {
                attrs: {
                  label: _vm.Lang.get("messages.phone"),
                  name: "phone",
                  model: _vm.request,
                  errors: _vm.formErrors,
                  type: "tel",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6" },
            [
              _c("form-input", {
                attrs: {
                  label: _vm.Lang.get("messages.password"),
                  name: "password",
                  model: _vm.request,
                  errors: _vm.formErrors,
                  type: "password",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "button",
                {
                  staticClass: "custom-btn confirm-btn",
                  attrs: { type: "submit", disabled: _vm.submitted },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Lang.get("messages.save")) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }